"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelatedList = exports.Body = exports.ObjectDetailNewBody = exports.ObjectDetailBarHeader = exports.NoVideoHeader = exports.VideoHeader = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _TabPanel = require("components/TabPanel");

var _VideoPlayer = babelHelpers.interopRequireDefault(require("VideoPlayer"));

var _ObjectDetailBar = babelHelpers.interopRequireDefault(require("components/ObjectDetailBar"));

var _class, _descriptor, _temp, _class3, _descriptor2, _temp2, _class5, _descriptor3, _descriptor4, _descriptor5, _temp3, _class7, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp4, _class9, _descriptor14, _descriptor15, _temp5;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ObjectDetailNew =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ObjectDetailNew, _Component);

  function ObjectDetailNew() {
    babelHelpers.classCallCheck(this, ObjectDetailNew);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ObjectDetailNew).apply(this, arguments));
  }

  babelHelpers.createClass(ObjectDetailNew, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(ObjectDetailNewBody, this.props.content);
    }
  }]);
  return ObjectDetailNew;
}(_react.Component);

exports.default = ObjectDetailNew;
var VideoHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(VideoHeader, _Component2);

  function VideoHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "video", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(VideoHeader, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "video-player"
      }, _react.default.createElement(_VideoPlayer.default, {
        lazy: this.video
      }));
    }
  }]);
  return VideoHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "video", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.VideoHeader = VideoHeader;
var NoVideoHeader = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(NoVideoHeader, _Component3);

  function NoVideoHeader() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, NoVideoHeader);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(NoVideoHeader)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "buttonTitle", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(NoVideoHeader, [{
    key: "noOp",
    value: function noOp() {}
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "video-player no-media-item-spacer",
        style: {
          visibility: 'hidden'
        }
      }, _react.default.createElement("div", {
        className: "video-player-button"
      }, _react.default.createElement("button", {
        "data-button-title": this.buttonTitle,
        onClick: this.noOp,
        type: "button"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "play_arrow"
      }))));
    }
  }]);
  return NoVideoHeader;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "buttonTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "noOp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "noOp"), _class3.prototype)), _class3);
exports.NoVideoHeader = NoVideoHeader;
var ObjectDetailBarHeader = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(ObjectDetailBarHeader, _Component4);

  function ObjectDetailBarHeader() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, ObjectDetailBarHeader);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(ObjectDetailBarHeader)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "bar", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "shareURL", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "shortShareURL", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    _this3.state = {
      ready: false,
      bar: _this3._evaluateBar()
    };
    return _this3;
  }

  babelHelpers.createClass(ObjectDetailBarHeader, [{
    key: "_evaluateBar",
    value: function _evaluateBar() {
      try {
        return Function('', "return ".concat(this.bar)).call(null);
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        ready: true
      });

      var S = require('share');

      S.setShareURL(this.shareURL, this.shortShareURL);
      ;
      S.setShareTitle(this.state.bar.title);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.bar != this.props.bar) {
        this.setState({
          bar: this._evaluateBar()
        });
      }

      var S = require('share');

      S.setShareURL(this.shareURL, this.shortShareURL);
      ;
      S.setShareTitle(this.state.bar.title);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.bar) return null;
      return _react.default.createElement("div", {
        id: "object-detail-bar",
        className: _classList.default.join('inner-content', this.state.bar.alternateLayout ? 'alternate-detail-bar' : 'detail-bar', this.state.ready ? 'animate-fadeIn' : '')
      }, this.state.ready && this.state.bar && _react.default.createElement(_ObjectDetailBar.default, this.state.bar));
    }
  }]);
  return ObjectDetailBarHeader;
}(_react.Component), _temp3), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "bar", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "shareURL", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "shortShareURL", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.ObjectDetailBarHeader = ObjectDetailBarHeader;
var ObjectDetailNewBody = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(ObjectDetailNewBody, _Component5);

  function ObjectDetailNewBody() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, ObjectDetailNewBody);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(ObjectDetailNewBody)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "id", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "background", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "tabs", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "relatedItemSet", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "footerContentStack", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "infoBar", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "header", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "headerClasses", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    _this4.state = {
      selectedTab: 0
    };
    return _this4;
  }

  babelHelpers.createClass(ObjectDetailNewBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        className: _classList.default.join('block', 'stack', 'large-header', 'course-detail', 'height-90vh', this.headerClasses, this.background && 'transparent variable-background'),
        style: _base.default.styleForBackgroundObject(this.background)
      }, _react.default.createElement("div", {
        className: "mobile-bg-overlay"
      }), this.renderPageHeaderContent()), this.renderInfoBar(), _react.default.createElement("div", {
        className: "block stack tabs"
      }, _react.default.createElement(_TabPanel.TabPanel, null, this.renderTabs())), this.renderEndContent(), this.renderRelatedItems(), this.renderAdditionalContentStack());
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      require('trackObjectView').default('catalog', this.id);
    }
  }, {
    key: "renderPageHeaderContent",
    value: function renderPageHeaderContent() {
      return this.header.map(function (node, index) {
        var r = require(node.type)[node.name || 'default'];

        return _react.default.createElement(r, Object.assign({
          key: index
        }, node));
      });
    }
  }, {
    key: "renderInfoBar",
    value: function renderInfoBar() {
      return this.infoBar.map(function (item, index) {
        return _react.default.createElement(require(item.type)[item.name || 'default'], Object.assign({
          key: index
        }, item));
      });
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      return this.tabs.map(function (tab, index) {
        return _react.default.createElement(tab.wrapper ? require(tab.wrapper.type)[tab.wrapper.name || 'default'] : _TabPanel.Tab, Object.assign({
          title: tab.title,
          key: index
        }, tab.wrapper || {}), _react.default.createElement(require(tab.type)[tab.name || 'default'], tab));
      });
    }
  }, {
    key: "renderEndContent",
    value: function renderEndContent() {
      return null;
    }
  }, {
    key: "renderRelatedItems",
    value: function renderRelatedItems() {
      return this.relatedItemSet.map(function (item, index) {
        return _react.default.createElement(RelatedList, _extends({
          key: index
        }, item));
      });
    }
  }, {
    key: "renderAdditionalContentStack",
    value: function renderAdditionalContentStack() {
      if (this.footerContentStack) {
        return _react.default.createElement(require(this.footerContentStack.child_type).default, this.footerContentStack);
      }

      return null;
    }
  }]);
  return ObjectDetailNewBody;
}(_react.Component), _temp4), (_descriptor6 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "tabs", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "relatedItemSet", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "footerContentStack", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "infoBar", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "header", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "headerClasses", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
})), _class7);
exports.Body = exports.ObjectDetailNewBody = ObjectDetailNewBody;
var RelatedList = (_class9 = (_temp5 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(RelatedList, _Component6);

  function RelatedList() {
    var _babelHelpers$getProt5;

    var _this5;

    babelHelpers.classCallCheck(this, RelatedList);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(RelatedList)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "title", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "content", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    return _this5;
  }

  babelHelpers.createClass(RelatedList, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "block stack catalog-group height-auto"
      }, _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("h1", null, this.title)), _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "card-container card-grid card-centered"
      }, this.content.map(function (item) {
        return _react.default.createElement(require(item.child_type).default, Object.assign({
          key: item.id
        }, item));
      }))));
    }
  }]);
  return RelatedList;
}(_react.Component), _temp5), (_descriptor14 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);
exports.RelatedList = RelatedList;